<template>
  <div>
    <table class="table">
      <thead>
        <tr>
          <th-orderable
            v-for="column in columns.filter(column => column_dict[column.key])"
            :key="column.key"
            :column="column"
            @click="column.orderable !== false ? onColumnClick(column) : null"
          />

          <!-- <th class="filter-table">{{ i18n.app.common.options }}</th> -->
        </tr>
      </thead>
      <tbody>
        <VehicleRow
          :column_dict="column_dict"
          @update="onUpdateItem"
          @cancel="onCancelItem"
          v-for="model in models"
          :model="model"
          v-bind:key="model.id"
        />
      </tbody>
    </table>
  </div>
</template>
<script>
import VehicleRow from "./VehicleRow";
import getColumns from "../misc/vehicle-columns";
import modelListMixin from "@/components/crud/mixins/model-list.mixin";
import ThOrderable from "@/components/common/table/ThOrderable";

const lang = i18n.app.components.vehicle;

export default {
  name: "vehicle-list",
  props: ["column_dict"],
  mixins: [modelListMixin],
  components: {
    VehicleRow,
    ThOrderable
  },
  mounted() {
    jQuery(document).ready(() => {
      this.initJQuery();
    });

  },
  data() {
    return {
      lang: lang,
      state: {
        page: 1
      },
      columns: getColumns()
    };
  },
  methods: {
    onColumnClick(column) {
      this.$emit("columnClick", column);
    },
    onCancelItem(item) {
      this.onDeleteItem(item);
    },
    onUpdateItem(oldItem, newItem) {
      const index = this.models.indexOf(oldItem);

      if (index > -1) {
        this.models[index] = newItem;
      }

      this.$forceUpdate();
    },
    initJQuery() {
      // Multiselect options
      $(".filter-table select").multiselect({
        buttonText: function(options, select) {
          return "Filter";
        },
        buttonTitle: function(options, select) {
          var labels = [];
          options.each(function() {
            labels.push($(this).text());
          });
          return labels.join(" - ");
        }
      });

      $(".filter-table-search select").multiselect({
        enableFiltering: true,
        filterPlaceholder: "Zoeken...",
        buttonText: function(options, select) {
          return "Filter";
        },
        buttonTitle: function(options, select) {
          var labels = [];
          options.each(function() {
            labels.push($(this).text());
          });
          return labels.join(" - ");
        }
      });
    }
  }
};
</script>
